// @flow

import React, { useContext } from 'react';
import type { Node } from 'react';
import { errors as ERRORS_ENUM } from 'Enum';
import { useQuery } from 'shared_services/apollo/useQuery';
import { useStoreCode } from 'shared_services/redux/hooks/useStoreCode';
import { RouteConfigContext } from 'shared_data/providers/routeconfig/Context';
import { CmsViewsProvider } from 'shared_components/cms/views/Provider';
import RENDER_CMS_VIEW_QUERY from 'shared_data/queries/cms/renderView.graphql';

type Props = {
  layoutQueryErrorHandler: Object,
};

/**
 * CmsViewLoader
 *
 * @param {Props} props
 * @returns Node
 */
export function CmsViewLoader({ layoutQueryErrorHandler }: Props): Node {
  const DEFAULT_LAYOUT_QUERY_CONTEXT = {
    customOptions: {
      errorSuppressFromResponse: true,
      // this custom errorFilter will iterate over the graphql errors (if any)
      // and will skip ResourceNotFoundException only for this query,
      // because on some pages we don't have CMS data to load and then it returns this ResourceNotFoundException
      errorFilter: (errorList: Object[] = []) =>
        errorList.filter((error) => error && error.errorType !== 'ResourceNotFoundException'),
      error: {
        handler: ERRORS_ENUM.handlers.SILENT,
      },
    },
  };
  const queryContext = { ...DEFAULT_LAYOUT_QUERY_CONTEXT, ...layoutQueryErrorHandler };
  const store = useStoreCode();
  const { module, cmsViewRenderSsr } = useContext(RouteConfigContext);
  const { loading, data } = useQuery(RENDER_CMS_VIEW_QUERY, {
    ssr: !!cmsViewRenderSsr,
    variables: { name: module, store },
    errorPolicy: 'all',
    context: queryContext,
    skip: !module || !store,
  });

  return <CmsViewsProvider loading={loading} data={data && data.renderCmsView} />;
}
